import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2e6c982&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d2e6c982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e6c982",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderBanner: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/PageHeaderBanner.vue').default,BreadCrumb: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/BreadCrumb.vue').default,Sidebar: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Sidebar.vue').default,Pagination: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Pagination.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default,InquiryForm: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InquiryForm.vue').default})
